module.exports = __webpack_public_path__ + "img/icon.8bdc9ae4.svg";